import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {
  // Resolved lazily (not as a field initializer) to avoid an NG0200 circular
  // dependency: TranslateService's HTTP loader depends on HttpClient, which
  // depends on this interceptor, which would otherwise depend on TranslateService.
  private injector = inject(Injector);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Escludi le chiamate ai file di traduzione, EVITA ERRORS DI RICORSIONE INFINITA con il translate service
    if (request.url.includes('/i18n/')) {
      return next.handle(request);
    }

    const translateService = this.injector.get(TranslateService);
    const currentLang =
      translateService.getCurrentLang() ||
      translateService.getFallbackLang();

    const modifiedRequest = request.clone({
      setHeaders: {
        'Accept-Language': currentLang,
      },
    });

    return next.handle(modifiedRequest);
  }
}
